import { requireCampaignList, campaignWorldDate } from '../shared/campaign-list-rows';
import { decodeHtmlEntitiesForPlainText as plain } from '../shared/decode-html-entities';

/** The campaign search's raw SELECT rows → its existing browser table view. */
export function campaignSearchRows(payload: unknown, root: string) {
    const data = requireCampaignList(payload);
    const viewer = (data.viewer_id ?? '').toUpperCase();
    return data.campaigns.map(row => {
        const id = row.campaign_id;
        const settings = data.viewer_staff || (viewer !== '' && [row.campaign_gm, row.campaign_created_by_id].some(owner => String(owner ?? '').toUpperCase() === viewer));
        return { id, name: plain(row.campaign_name), url: new URL(`campaign.php?campaign_id=${encodeURIComponent(id)}`, root).href,
            world: { id: String(row.world_id ?? ''), label: plain(row.world_name) },
            calendar: { id: String(row.calendar_id ?? ''), label: plain(row.calendar_name) },
            worldDate: campaignWorldDate(row), gm: { id: String(row.campaign_gm ?? ''), label: plain(row.gm_username) },
            playerCount: Number(row.count_campaign_players ?? 0), startDate: String(row.campaign_start_date ?? ''), endDate: String(row.campaign_end_date ?? ''),
            actions: [{ kind: 'navigate', enabled: true }, ...(settings ? [{ kind: 'campaign_settings', enabled: true }] : [])] };
    });
}
